import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/Redux/RootReducer';

const documentPrintState = (state: RootState) => state.modalWindows.documentPrintModalState;

const currentStep = createSelector(documentPrintState, (state) => state.currentStep);

const documentType = createSelector(documentPrintState, (state) => state.documentType);

const documentTemplates = createSelector(documentPrintState, (state) => state.documentTemplates);

const selectedDocumentTemplate = createSelector(documentPrintState, (state) => state.selectedDocumentTemplate);

const selectedTypeNumbers = createSelector(documentPrintState, (state) => state.selectedTypeNumbers);

const documentNumbersInfo = createSelector(documentPrintState, (state) => state.documentNumbersInfo);

const selectedNumbersInfo = createSelector(documentPrintState, (state) => state.selectedNumbersInfo);

export const documentPrintModalSelectors = {
  currentStep,
  documentType,
  documentTemplates,
  selectedDocumentTemplate,
  selectedTypeNumbers,
  documentNumbersInfo,
  selectedNumbersInfo,
};
